import React, { useState, useRef, useEffect } from 'react'
import "./RetirmentPlans.less"
import Retirmentjson from "../../Configs/JSON/RetirmentPlans.json"
import DOMPurify from "dompurify"
import { Divider } from 'antd'
import { GrabToHScroll } from "../Common/CommonFunctions"
import AppStore from "../../Configs/Store/index"
import ScrollControl from "../Common/ScrollControl/ScrollControl"
import { DataLayerFn } from "../../Configs/API"
import CalculatorStore from "../../Configs/Store/calculator"


const RetirmentPlans = () => {
	const [ScrollPercent, setScrollPercent] = useState("")
	const RecommendedScroll = useRef({})
	const [RECOM_DATA, setRECOM_DATA] = useState([])


	useEffect(() => {
		if (AppStore.device === 1) {
			setTimeout(GrabToHScroll, 250, "RetirmentPlansmain")
		}
	}, [RECOM_DATA])
	const progressPercent = (e) => {
		var percent = parseInt((100 * e.target.scrollLeft) / (e.target.scrollWidth - e.target.clientWidth))
		setScrollPercent(percent)
	}

	useEffect(() => {
		setRECOM_DATA(Retirmentjson.cardContents)
	}, [])
	const Cardsjson = Retirmentjson.cardContents
	return (
    <div className="RetirmentPlansRoot">
      <div className="RetirmentPlansmain" ref={RecommendedScroll} onScroll={progressPercent}>
        {RECOM_DATA.map((value, index) => (
          <div className="RetirmentPlansCards">
            <div className="CardsHead1">
              <div dangerouslySetInnerHTML={{ __html: value.header }}/>
            </div>
            <div className="Card2">
              {value.subTitle2 ? <div className="CardsHead4" dangerouslySetInnerHTML={{ __html: value.subTitle2 }}/> : <div></div>}
              <div className="CardsHead">
                <img src={value.icon} alt="" />
                <div>
                  <div className="CardsHead2">{value.title}</div>
                  {value.subTitle ? <div className="CardsHead3">{value.subTitle}</div> : <div></div>}
                </div>
              </div>
              <Divider />

              <div className="cardsMain">
                <div className="cardMainMenu">
                  {value.content.map((e) => (
                    <div className="CardContent">
                      <img src="assets/RetirmentPlans/red_tick_icon.svg" />
                      <div dangerouslySetInnerHTML={{ __html: e }}></div>
                    </div>
                  ))}
                </div>
                {value.visible === true ? <div className='disclaimerClass' dangerouslySetInnerHTML={{ __html: value.disclaimer }}></div> : <div className="visibleFalse"></div>}
              </div>
              <div className="CardsFooter">
                <div
                  className="knowMore"
                  onClick={() => {
                    try {
                      DataLayerFn("KnowMore_Selected", CalculatorStore, "Know More")
                    } catch {}
                  }}
                  dangerouslySetInnerHTML={{ __html: value.knowMore }}
                ></div>
                <div
                  className="CheckReturns"
                  onClick={() => {
                    try {
                      DataLayerFn("CheckRetrun_Selected", CalculatorStore, "Check Return")
                    } catch {}
                  }}
                  dangerouslySetInnerHTML={{ __html: value.CheckReturn }}
                ></div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <ScrollControl targetRef={RecommendedScroll} className={"Recommended_List"} subItem={"Item1"} effectProps={AppStore.device} scrollPercent={ScrollPercent} />
    </div>
  )
}

export default RetirmentPlans